import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./WhatsAppWidget.css";
import api from "./api";

const WhatsAppWidget = () => {
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const message = "Hello! I need some help.";

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const { data } = await api.get("/frontend/site-settings");
        if (data.success && data.data.whatsappNumber) {
          setWhatsappNumber(data.data.whatsappNumber);
        }
      } catch (error) {
        console.error("Failed to fetch WhatsApp number", error);
      }
    };
    fetchSettings();
  }, []);

  if (!whatsappNumber) return null;

  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      aria-label="Chat on WhatsApp"
    >
      <div className="whatsapp-icon-container">
        <FaWhatsapp className="whatsapp-icon" />
        <span className="pulse"></span>
      </div>
    </a>
  );
};

export default WhatsAppWidget;
